import { FC } from 'react';
import { SegmentedControlProps } from './SegmentedControl.types';
import { Flex } from '@/_components';
import styles from './SegmentedControl.module.css';
import { getClasses } from '@/_utils/classnames';

export const SegmentedControl: FC<SegmentedControlProps> = ({
  children,
  isFullWidth,
}) => {
  const segmentedControlClasses: string = getClasses(styles.segmentedControl, {
    [styles.segmentedControlFull]: isFullWidth,
  });

  return (
    <Flex className={segmentedControlClasses} isYCentered={true} gap={2}>
      {children}
    </Flex>
  );
};
